import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { actionSet } from './utils'
import { getPages } from 'component/pagination/utils'
import { showSpinner, hideSpinner } from 'action/spinner'

import {
  FETCH_DELIMIT_REPORT_REQUEST,
  FETCH_DELIMIT_REPORT_SUCCESS,
  FETCH_DELIMIT_REPORT_ERROR,
} from 'actionTypes'

export const fetch = (token, param) => async (dispatch) => {
  try {
    dispatch(showSpinner())

    dispatch(actionSet(FETCH_DELIMIT_REPORT_REQUEST))

    const response = await new Api(token, dispatch).post(
      API_URL.DELIMIT_REPORT,
      param
    )

    dispatch(getPages(response.metadata))

    return dispatch(actionSet(FETCH_DELIMIT_REPORT_SUCCESS, response.data))
  } catch (error) {
    return dispatch(actionSet(FETCH_DELIMIT_REPORT_ERROR, error))
  } finally {
    dispatch(hideSpinner())
  }
}
